import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';

var AssignmentsBoxWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  padding: 4rem;\n  border-radius: 8px;\n  background-color: ", ";\n\n  cursor: pointer;\n\n  &:hover {\n    background-color: #fff;\n    box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.12);\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: none;\n  }\n\n  /* Icon */\n  svg {\n    position: absolute;\n    top: 4rem;\n    right: 4rem;\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n  position: relative;\n\n  padding: 4rem;\n  border-radius: 8px;\n  background-color: ", ";\n\n  cursor: pointer;\n\n  &:hover {\n    background-color: #fff;\n    box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.12);\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: none;\n  }\n\n  /* Icon */\n  svg {\n    position: absolute;\n    top: 4rem;\n    right: 4rem;\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray4;
});
var templateObject_1;

export { AssignmentsBoxWrapper };
